import React from 'react';

import {Highlight, getIndexesOfMatches} from '@pb/kit-component-highlight';

type Props = {
    text: string,
    highlightedText: string,
};

export const HighlightedText = ({text, highlightedText}: Props) => {
    const matchedChunks = getIndexesOfMatches(text, highlightedText);

    return (
        <Highlight text={text} matchedChunks={matchedChunks}/>
    );
};
